import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { useHome } from "@/context/HomeContent";
import { REAL } from "@/data";
import { fadeUp, staggerParent, viewportOnce } from "@/lib/animations";

const Counter = ({ to, inView }) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, { duration: 2, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setVal(Math.round(v)) });
    return () => controls.stop();
  }, [inView, to]);
  return <>{val}+</>;
};

const Impact = () => {
  const { home } = useHome();
  const d = home.impact;
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section id="impact" ref={ref} data-testid="impact-section" className="grain relative overflow-hidden bg-brand-ink py-24 text-white sm:py-32">
      <div className="absolute inset-0">
        <img src={REAL.crowdSelfie} alt="Participants celebrating at a Jadoo Ki Jhappy program" className="h-full w-full object-cover object-center opacity-[0.16]" />
        <div className="absolute inset-0 bg-brand-ink/75" />
      </div>
      <div className="pointer-events-none absolute -right-32 top-0 h-96 w-96 rounded-full bg-brand-magenta/20 blur-[120px]" />

      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="mb-5 font-heading text-xs font-bold uppercase tracking-[0.22em] text-brand-pink">{d.eyebrow}</p>
          <h2 className="font-heading text-4xl font-semibold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
            {d.headingLead} <span className="text-brand-pink">{d.headingAccent}</span>
          </h2>
        </div>

        <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={viewportOnce} className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {(d.stats || []).map((s) => (
            <motion.div key={s.label} variants={fadeUp} className="bg-brand-ink/60 p-8 backdrop-blur-sm lg:p-10" data-testid={`impact-stat-${s.label.split(" ")[0].toLowerCase()}`}>
              <div className="brand-gradient-text font-heading text-5xl font-bold leading-none sm:text-6xl">
                {s.animate ? <Counter to={s.to} inView={inView} /> : s.value}
              </div>
              <p className="mt-4 font-body text-sm leading-snug text-white/60">{s.label}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Impact;
